import { callApi, SERVER_TYPES } from "../../api";
import { schema } from "normalizr";
import { Schemas as clinicalContentShemas } from "../clinical_content/api";
import moment from "moment-timezone";
import _ from "lodash";
import { AMPLIO_ANALITICS_REQUEST_TYPES } from "@app/constants";

export { loadTherapistTodaysSessions, loadStudent, updateStudent, loadUserCalendarCreateOptions, loadAllStudentsNoInactive } from "@amplio-common/users/api";

const usersSchema = new schema.Entity("users", {}, {
  idAttribute: user => user.id,
});

const studentSchema = new schema.Entity("students", {
  // goal_set: clinicalContentShemas.GOAL_ARRAY
}, {
  idAttribute: user => user.id,
});

const therapistSchema = new schema.Entity("therapists", {
}, {
  idAttribute: user => user.id,
});

const userAgreementSchema = new schema.Entity("userAgreements", {
  agreement: clinicalContentShemas.AGREEMENT,
}, {
  idAttribute: userAgreement => userAgreement.id,
});

export const Schemas = {
  USER_ARRAY: [usersSchema],
  USER: usersSchema,
  STUDENT: studentSchema,
  STUDENT_ARRAY: [studentSchema],
  THERAPIST: therapistSchema,
  THERAPIST_ARRAY: [therapistSchema],
  USER_AGREEMENT: userAgreementSchema,
  USER_AGREEMENT_ARRAY: [userAgreementSchema],
};

// api services
export const loadUser = (userId) => callApi(`users/${userId}/`, { method: "GET" });
export const loadUserWithCalendar = (userId) => {
  let path = `users/${userId}/calendar/`;
  if (localStorage.getItem("class_login_token")) {
    path = "class_code/calendar/";
  } else if (localStorage.getItem("code_login_token")) {
    path = "student_code/calendar/";
  }
  return callApi(path, { method: "GET" });
};
export const loadUserDashboard = () => callApi("users/my_dashboard/", { method: "GET" });
export const loadSpedUserDashboard = (role) => callApi(`users/?role=${role}`, { method: "GET" });
export const loadUserDrawings = (id) => callApi(`student_code/student_images/?id=${id}`, { method: "GET" });
export const loadTreatmentActivities = async (treatmentId, studentId) => {
  const { response } = await callApi(`treatment/activity_history/?id=${treatmentId}&student_id=${studentId}`, { method: "GET" });
  return response.activity_history;
};

//start_date, end_date, user_id
export const loadVisualEvents = (params) => callApi(
  "visual-events/",
  {
    method: "GET",
    params,
  },
  undefined,
  SERVER_TYPES.CALENDAR,
);

export const loadUsersV2 = async (filters, isEdited = false) => {
  const queryParams = filters ? Object.keys(filters).reduce((res, item) => res += (filters[item] !== null && filters[item] !== undefined) ? `${item}=${encodeURIComponent(filters[item])}&` : "", "?").slice(0, -1) : "";
  const res = await callApi(`users/v2/${queryParams}`, {});
  return { response: { ...res.response, isEdited } };
};

export const loadUsersInClinic = async (clinicId, filters) => {
  const queryParams = filters ? Object.keys(filters).reduce((res, item) => res += (filters[item] !== null && filters[item] !== undefined) ? `${item}=${encodeURIComponent(filters[item])}&` : "", "?").slice(0, -1) : "";
  const res = await callApi(`clinics/${clinicId}/users/${queryParams}`, {});
  return { response: { ...res.response } };
};

export const loadStudentsInDirect = async (filters) => {
  const queryParams = filters ? Object.keys(filters).reduce((res, item) => res += (filters[item] !== null && filters[item] !== undefined) ? `${item}=${encodeURIComponent(filters[item])}&` : "", "?").slice(0, -1) : "";
  const res = await callApi(`students/indirect/${queryParams}`, {});
  
  return res;
};


export const loadUsers = (userId) => callApi(`users/${userId ? `?user_id=${userId}` : ""}`, {}, Schemas.USER_ARRAY);

export const deleteUser = (userId) => _.isArray(userId) ? callApi(`users/${userId.toString().replaceAll(",", "&")}/`, { method: "DELETE" }) : callApi(`users/${userId}/`, { method: "DELETE" });

export const editUser = (userId, user) => callApi(`users/${userId}/`, { method: "PATCH", type: "JSON", body: user });

export const loadSpecificRecord = (recordId) => callApi(`recordings/${recordId}/file_path/`, {
  method: "GET",
});

export const createUser = (user) => callApi("users/", {
  method: "POST",
  type: "JSON",
  body: user,
});

export const createStudent = (user) => callApi("students/", {
  method: "POST",
  type: "JSON",
  body: user,
});



export const loadStudentsUpcomingSessions = (studentsArr) => callApi(`students/upcoming_sessions/?student_id=${studentsArr.join(",")}`, { method: "GET" });

export const loadStudents = (useSchema = true) => callApi("students/", {
  method: "GET",
}, useSchema ? Schemas.STUDENT_ARRAY : undefined);

export const loadAllStudents = (therapistId, useSchema = false) => callApi(`students/?all=false${therapistId ? `&therapist_id=${therapistId}` : ""}`, { method: "GET" }, useSchema ? Schemas.STUDENT_ARRAY : null);


export const updateStudentLanguage = (lang) => callApi("users/lang/", {
  method: "PATCH",
  type: "JSON",
  body: { lang },
});

export const loadStudentAgreements = (useSchema = true) => callApi("users/consents/", {
  method: "GET",
}, useSchema ? Schemas.USER_AGREEMENT_ARRAY : null);

export const saveStudentAgreements = (agreements, areaOfNeedAgreement) => callApi("users/consents/", {
  method: "POST",
  type: "JSON",
  body: { agreements, areaOfNeedAgreement },
});

export const validateNewStudentsFile = (body, files) => callApi("students/validate_students_file/", {
  method: "POST",
  body,
  files,
});

export const uploadNewStudentsFile = (body, files) => callApi("students/upload_students_file/", {
  method: "POST",
  body,
  files,
});

export const loadStudentFiles = (studentId) => callApi(`students/${studentId}/files/`, {
  method: "GET",
});

export const uploadStudentFiles = (studentId, files) => callApi(`students/${studentId}/files/`, {
  method: "POST",
  files,
});

export const loadTestResults = (studentId) => callApi(`slq_tests/student/${studentId}/results/`, {
  method: "GET",
});

export const loadStudentSessions = () => callApi("students/myTherapySessions/", {});

export const loadStudentFile = (studentId, fileName) => callApi(`students/file/${studentId}/?file_name=${fileName}`, {
  method: "GET",
});

export const deleteStudentFile = (studentId, fileName) => callApi(`students/${studentId}/files/?file_name=${fileName}`, {
  method: "DELETE",
});

export const loadStudentSelfPracticeByObjective = (studentId, objectiveId) => callApi(`students/${studentId}/self_practice/?objective_id=${objectiveId}`, {
  method: "GET",
});

export const getPOCs = (studentId) => callApi(`students/${studentId}/pocs/`, { method: "GET" });
export const getPOCbyId = (studentId, poc) => callApi(`students/${studentId}/pocs/?id=${poc}`, {
  method: "GET",
  type: "PDF",
});

export const createPOC = (studentId, data) => callApi(`students/${studentId}/pocs/`, {
  method: "POST",
  type: "JSON",
  body: data,
});

export const getPOCDefaultsByServiceId = (studentId, serviceId) => callApi(`students/${studentId}/poc_defaults/?service_id=${serviceId}`, { method: "GET" });

export const getParticipance = (studentId) => callApi(
  `analytics/session/participance/?student_id=${studentId}`, { method: "GET" },
);

export const getPracticeDuration = (studentId) => callApi(
  `analytics/session/practice_duration/?student_id=${studentId}`, { method: "GET" },
);

export const getWordForRecord = (studentId) => callApi(
  `treatments/articulation_recordings/?student=${studentId}`,
  { method: "GET" },
);

export const setFeedbackScore = (recording_id, result) => callApi(`treatments/articulation_recordings/${recording_id}/`,
  {
    method: "PATCH",
    type: "JSON",
    body: { result },
  });

export const getUserVocabulary = (studentId) => callApi(
  `analytics/vocabulary/user_vocabulary/?student_id=${studentId}`, { method: "GET" },
);

export const getSelfPracticeAiGame = (studentId, course_id, start_date, end_date) => callApi(
  `students/${studentId}/self_practice_aigame/?${course_id ? `&course_id=${course_id}` : ""}${start_date ? `&start_date=${start_date}` : ""}${end_date ? `&end_date=${end_date}` : ""}`, { method: "GET" },
);

export const getMultiplePOCReport = (students, version = 1, serviceId) => callApi("students/plan_of_care/", {
  method: "POST",
  body: { students, version, service_id: serviceId },
  type: "PDF",
});
export const getPOCReport = (studentId) => getMultiplePOCReport([parseInt(studentId)]);

// Therapist appears in PDF
// Need to change in server side
export const getMedicaidReport = (students, startDate, endDate, serviceId) => callApi("students/medicaid_report/", {
  method: "POST",
  body: { students,
    start_date: moment(startDate).format("YYYY-MM-DDT00:00+00:00"),
    end_date: moment(endDate).format("YYYY-MM-DDT23:59+00:00"),
    service_id: serviceId,
  },
  type: "PDF",
});

export const getLessonPlanReport = (student_id, startDate, endDate, serviceId) => callApi("students/lesson_plan_report/", {
  method: "POST",
  body: { student_id,
    start_date: moment(startDate).format("YYYY-MM-DDT00:00+00:00"),
    end_date: moment(endDate).format("YYYY-MM-DDT23:59+00:00"),
    service_id: serviceId,
  },
  type: "PDF",
});

export const getNetworkTestSessionCreds = () => callApi("users/network_test_session_creds/", { method: "GET" });

export const logNetworkQualityTest = (data) => callApi("users/network_quality_test/", {
  method: "POST",
  type: "JSON",
  body: data,
});


export const loadAreasOfNeed = () => callApi("areas_of_need/", { method: "GET" });

// eslint-disable-next-line max-len
export const loadStudentDyslexiaReport = (userId, start_date, end_date, pdf = false) => {
  const queryParams = `start_date=${start_date}&end_date=${end_date}&pdf=${pdf}`;
  return callApi(`students/${userId}/dyslexia_report/?${queryParams}`, { method: "GET" });
};

export const getStudentPerformanceReport = (data, startDate, endDate, studentPesonalData, current_time, customProgressData) => callApi("students/dyslexia_performance_report/", {
  method: "POST",
  body: {
    dyslexia_data: data,
    start_date: moment(startDate).format("DD-MMM-YYYY T00:00"),
    end_date: moment(endDate).format("DD-MMM-YYYY T23:59"),
    studentPesonalData,
    current_time,
    customProgressData,
  },
  type: "PDF",
});

export const reportDownloadLog = (startDate, endDate, docName, adtData) => callApi("students/report_download_log/", {
  method: "POST",
  body: {
    report_start_date: moment(startDate).format("YYYY-MM-DDT00:00+00:00"),
    report_end_date: moment(endDate).format("YYYY-MM-DDT23:59+00:00"),
    document_name: docName,
    additional_data: adtData,
  },
});

export const getAnalitics = (studentId, requestType = AMPLIO_ANALITICS_REQUEST_TYPES.TIME_SERIES, startDay) => {
  const queryParams = `${startDay ? `?start__gte=${startDay}` : ""}`;
  return callApi(
    `api/v1/user/${studentId}/${requestType}/${queryParams}`,
    { method: "GET" },
    undefined,
    SERVER_TYPES.ANALYTICS,
  );
};

export const getLastThreeTreatmentsData = (studentId, endDay, limit) => callApi(
  `api/v1/user/${studentId}/time_aggregate_summary/?end_date=${endDay}&limit=${limit}`,
  { method: "GET" },
  undefined,
  SERVER_TYPES.ANALYTICS,
);

export const getResultsDataBydate = (studentId, date, objective, protocol, skillsId) => {
  let uri = `api/v1/user/${studentId}/time_aggregate_details/?date=${date}&objective=${objective}&protocol=${protocol}`;
  uri = skillsId ? `${uri}&skills_id=${skillsId}` : uri;
  return callApi(
    uri,
    { method: "GET" },
    undefined,
    SERVER_TYPES.ANALYTICS,
  );
};

export const getReadingGameData = (studentId, endDay, limit) => callApi(
  `api/v1/user/${studentId}/reading_time_aggregate_summary/?end_date=${endDay}&limit=${limit}`,
  { method: "GET" },
  undefined,
  SERVER_TYPES.ANALYTICS,
);

export const getSpellingGameData = (studentId, endDay, limit) => callApi(
  `api/v1/user/${studentId}/spelling_time_aggregate_summary/?end_date=${endDay}&limit=${limit}`,
  { method: "GET" },
  undefined,
  SERVER_TYPES.ANALYTICS,
);

export const loadHashedRecord = (recordingHash) => callApi("v1/recordings/student", {
  method: "POST",
  type: "JSON",
  body: {
    recording_hash: recordingHash,
  },
}, undefined, SERVER_TYPES.RECORDINGS);

export const loadStudentsGoals = (studentList, statusList) => callApi(`students/goals/?student_ids=${studentList.join(",")}${statusList ? `&goal_status=${statusList.join(",")}` : ""}`, {
  method: "GET",
});
